import script from "./ManualPaymentRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./ManualPaymentRecord.vue?vue&type=script&setup=true&lang=js"

import "./ManualPaymentRecord.vue?vue&type=style&index=0&id=4fb18a07&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fb18a07"]])

export default __exports__